import React, { FunctionComponent } from 'react';
import { Input } from '@chakra-ui/react';

import { useAppDispatch, useAppSelector } from '@/store';
import { adActions } from '@/store/ad';
import { AdAttribute } from '@/store/ad/types';

export type DateInputProps = {
  attribute: AdAttribute;
};

export const DateInput: FunctionComponent<DateInputProps> = ({ attribute }) => {
  const dispatch = useAppDispatch();
  const { formData } = useAppSelector((state) => state.ad);

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(adActions.updateFormData({ key: attribute.id, value: e.target.value }));
  };

  return (
    <Input
      type="date"
      name={attribute.name || attribute.id.toString()}
      value={formData[attribute.id]?.value || ''}
      onChange={handleOnChange}
    />
  );
};
